/*** To get Cutomer Id / Shop Domain / Session Id For Wishlist***/
const shopDomain = window.Shopify.shop;
const sessionId = localStorage.getItem('sessionId');
const customerId = jQuery("#customer_id").val(); 

/*** Get Wishlist Product Count Start ***/
function getWishlistProducts() {    
    var wishlistApiUrl = siteUrl+"/tools/xb-wishlist?customerId="+customerId+"&sessionId="+sessionId;

    if(sessionId != '' && sessionId != null && sessionId != undefined){              
        jQuery.ajax({
          url: wishlistApiUrl,
          type: 'get',
          async: 'false',
          success: function(response){           
            var wishlistProducts = response.wishlist;
            var wishlistProductArray = [];
            
            if(wishlistProducts.length > 0){
              $.each(wishlistProducts, function (i, product) { 
                wishlistProductArray.push(product.productId); 
              });
            }

            $("#wishlist_products").val(wishlistProductArray);              
          }
        });
    }     
}
/*** Get Wishlist Product Count End ***/